import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useEffect } from "preact/hooks";
import { colorFacets } from "../../config.js"

export default function ColorFacet({ facet }) {
    const { toggleProductFilter } = useFacet(facet);

    const handleFilterToggle = (curValue) => {
        toggleProductFilter(facet.field, curValue.value, !curValue.selected);
        const matchingValue = facet.data?.find(data => data.value === curValue.value.toUpperCase());
        if(matchingValue) {
            toggleProductFilter(facet.field, matchingValue.value, !curValue.selected);
        }
    };

    return (
        <div className="ns-facet">
            <div
                className="ns-facet__header"
                data-nosto-element="facet"
            >
                {facet.name}
            </div>
            <div className="ns-facet__body">
                <ul className="ns-facet__filters-list ns-m-0 colors-list">
                    {facet.data?.map(value => {
                        return (value.value !== value.value.toUpperCase())
                            ?   (<li
                                        className="ns-facet__filters-item"
                                        data-nosto-element="facet-setting"
                                        key={value.value}
                                    >
                                        <label
                                            className={`ns-checkbox ${value === 'White' ? "ns-swatch-border" : ""}`}
                                            style={`--color-hex: ${colorFacets[value.value.toLowerCase()]}`}
                                        >
                                            <span class={`ns-color-swatch color-swatches--${value.value.toLowerCase().replaceAll(' ', '-')}`}></span>
                                            <input
                                                className="visually-hidden"
                                                type="checkbox"
                                                checked={value.selected}
                                                onChange={e => {
                                                    e.preventDefault()
                                                    handleFilterToggle(value)
                                                }}
                                            />
                                            <span aria-hidden="true">{value.value}</span>
                                            <span className="sr-only">{value.value} ({value.count})</span>
                                        </label>
                                    </li>
                                )
                            :   null
                        }
                    )}
                </ul>
            </div>
        </div>
    )
}
